/**
 * 验证流程的本地缓存 key 值
 */
export const cacheKey = {
    aided: 'mmc.review.aided',
    payee: 'mmc.review.payee',
};
